import React from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TemporaryDrawerSubList from './TemporaryDrawerSubList';
import { Link } from "react-router-dom";


const TemporaryDrawerList = ({routes}) => {
  return (
    <List component="nav">
      {NavigationMenuMaker(routes)}
    </List>
  )
}


function NavigationMenuMaker(allowedRoutesList) {
  let routes = [];

  // Creates a buttons and menu buttons according to the given list
  if (allowedRoutesList && allowedRoutesList.length > 0 ) {

    // The array contains basic header buttons and also
    // Menu buttons where the navigation buttons are inside the menu
    for (let i = 0; i < allowedRoutesList.length; i++) {
      const routeInfo = allowedRoutesList[i];
      
      if (routeInfo.title && routeInfo.pages) {
          routes.push(<TemporaryDrawerSubList key={routeInfo.title} title={routeInfo.title} routes={routeInfo.pages} />)
      } else {
        routes.push(
          <ListItem button key={routeInfo.name} component={Link} to={routeInfo.path}> 
            <ListItemText primary={routeInfo.name}/>
          </ListItem>)
      }

    }
  } else { routes = null }
  return routes;
}

export default TemporaryDrawerList;


// WEBPACK FOOTER //
// ./src/components/Header/TemporaryDrawerList.js